import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICarrierAreaResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetCarrierAreaCommand
    extends IRequestCommand<
    ICarrierAreaResponseDTO,
    ErrorDetails,
    IGetCarrierAreaRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.GET;

    public override setParameters(parameters: IGetCarrierAreaRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.urlSections.push(`${parameters.id}`);
        this.composeUrl();
    }
}

export interface IGetCarrierAreaRequest extends ICommandParameters {
    carrierId: number;
    id: number;
}
